var document = require('../internals/global').document;

module.exports = document && document.documentElement;
